import { Pipe, PipeTransform } from '@angular/core';

/**
 * Gibt den übergebenen boolean-Wert besser lesbar als Ja/Nein zurück
 */
@Pipe({name: 'readableBool' })
export class ReadableBoolPipe implements PipeTransform {
  transform(value: boolean): string {
    return (value) ? 'Ja' : 'Nein';
  }
}